module.exports = __webpack_public_path__ + "static/media/BI_Dashboard_icon.de83b120.png";